import { db, functions } from '@/firebase'

export default {
    getZCierres({ commit, rootState }) {
        const negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio)
            .collection('cierrestpv')
            .orderBy('inicio', 'desc')
            .limit(100)
            .get()
            .then((r) => {
                console.log(r.docs.map(c => {
                    return {
                        id: c.id,
                        ...c.data()
                    }
                }))
                commit('setZCierres', r.docs.map(c => {
                    return {
                        id: c.id,
                        ...c.data()
                    }
                }));
            })
            .catch(e => console.log(e))
    },
    getZCierreConcreto({ rootState }, id) {
        const negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio)
            .collection('cierrestpv')
            .doc(id)
            .get()
            .then((r) => {
                if (r.exists) {
                    return {
                        ...r.data(),
                        id: id
                    }
                }
            })
            .catch(e => console.log(e))
    },
    getZCierresAbiertosTiempoReal({ commit, rootState }) {
        const negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio)
            .collection('cierrestpv')
            .where('estado', '==', 'abierto')
            .orderBy('inicio', 'desc')
            .onSnapshot((r) => {
                console.log(r.size);
                commit('setZCierresAbiertos', r.docs.map(c => {
                    return {
                        id: c.id,
                        ...c.data()
                    }
                }));
            })

    }
}